<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              {{ $t('gr102.greenTemperature') }}
            </div>
          </section>
          <section class="section02" v-show="userInfo.userRole !== 'ClubManager'" v-if="false">
            <div class="object01"></div>
            <div class="object02">
              <div class="form">
                <div class="formSelect" ref="select01">
                  <!--<div class="formSelectList" @click="openSelect01">-->
                  <div class="formSelectList">
                    <input type="text" v-model="currentClubInfo.club_name" :placeholder="$t('gr102.selectGolfClubPlaceholder')" readonly />
                  </div>
                  <div class="formSelectPopup typeSearch select01">
                    <div class="formSelectPopup-container">
                      <div class="outer">
                        <div class="inner">
                          <div class="formSelectPopup-box">
                            <div class="formSelectPopup-zone">
                              <div class="formSelectPopup-header">
                                <input type="text" :placeholder="$t('gr102.selectGolfClubPlaceholder')" v-model="searchValue" v-on:keyup="changeSearchValue" />
                              </div>
                              <ul class="formSelectPopup-body">
                                <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                                  <label>
                                    <input type="radio" v-model="selectCcode" :value="clubInfo.ccode" v-on:change="confirmSelect01()"/>
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                                  </label>
                                </li>
                              </ul>
                              <div class="formSelectPopup-footer">
                                <button class="formSelectPopup-cancel" @click="closeSelectAll()">
                                  {{ $t('common.cancel') }}
                                </button>
                                <!-- 비활성(Attribute) : disabled -->
                                <button class="formSelectPopup-confirm" @click="confirmSelect01()">
                                  {{ $t('common.confirm') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section03">
            <!-- 기간별 그린 온도 활성(Class) : term -->
            <div class="object01 term">
              <div class="title">
                <ul class="list">
                  <li class="time" @click="moveMenu(`/GR101` + getCurrentCcodeParam())">
                    {{ $t('gr102.hourlyGreenTemperature') }}
                  </li>
                  <li class="term" @click="closeSelectAll">
                    {{ $t('gr102.periodGreenTemperature') }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="object02">
              <div class="formSelect" ref="select02">
                <div class="formSelectList" @click="openSelect02">
                  <input type="text" :value="$t('gr102.periodGreenTemperature')" readonly />
                </div>
                <div class="formSelectPopup select02">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" :placeholder="$t('gr102.selectTypePlaceholder')" />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li @click="moveMenu(`/GR101`)">
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>{{ $t('gr102.hourlyGreenTemperature') }}</span>
                                </label>
                              </li>
                              <li @click="closeSelectAll">
                                <label>
                                  <input type="radio" checked/>
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>{{ $t('gr102.periodGreenTemperature') }}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                {{ $t('common.cancel') }}
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                {{ $t('common.confirm') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section04">
            <div class="object01"></div>
            <div class="object02">
              <div class="form">
                <ul class="month">
                  <!-- 활성(Class) : active -->
                  <li @click="setSearchPeriod(1)">
                    {{ $t('gr102.oneMonth') }}
                  </li>
                  <li @click="setSearchPeriod(3)">
                    {{ $t('gr102.threeMonths') }}
                  </li>
                  <li @click="setSearchPeriod(6)">
                    {{ $t('gr102.sixMonths') }}
                  </li>
                </ul>
                <div class="formCalendar">
                  <div class="formCalendarList">
                    <date-picker
                      v-model="dateRange"
                      type="date" range
                      :format="'YYYY-MM-DD'"
                      :clearable="false"
                      @change="updateValues"
                    >
                      <template v-slot:footer="{ emit }">
                        <div style="text-align: left">
                          <button class="mx-btn mx-btn-text" @click="setSearchPeriod(1, emit)">
                            {{ $t('gr102.oneMonth') }}
                          </button>
                          <button class="mx-btn mx-btn-text" @click="setSearchPeriod(3, emit)">
                            {{ $t('gr102.threeMonths') }}
                          </button>
                          <button class="mx-btn mx-btn-text" @click="setSearchPeriod(6, emit)">
                            {{ $t('gr102.sixMonths') }}
                          </button>
                        </div>
                      </template>
                    </date-picker>
                  </div>
                </div>
                <div class="formSelect" ref="select03">
                  <div class="formSelectList" @click="openSelect03">
                    <input type="text" v-model="currentCourseInfo.name" :placeholder="$t('common.course')" readonly />
                  </div>
                  <div class="formSelectPopup select03">
                    <div class="formSelectPopup-container">
                      <div class="outer">
                        <div class="inner">
                          <div class="formSelectPopup-box">
                            <div class="formSelectPopup-zone">
                              <div class="formSelectPopup-header">
                                <input type="text" :placeholder="$t('gr102.selectTypePlaceholder')" />
                              </div>
                              <ul class="formSelectPopup-body">
                                <li v-for="courseInfo in courseList" :key="courseInfo.courseId">
                                  <label>
                                    <input type="radio" v-model="selectCourseId" :value="courseInfo.courseId" v-on:change="confirmSelect03()"/>
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>{{courseInfo.name}}</span>
                                  </label>
                                </li>
                              </ul>
                              <div class="formSelectPopup-footer">
                                <button class="formSelectPopup-cancel">
                                  {{ $t('common.cancel') }}
                                </button>
                                <!-- 비활성(Attribute) : disabled -->
                                <button class="formSelectPopup-confirm">
                                  {{ $t('common.confirm') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section05 scroll-body">
            <!-- 데이터 없을때(Class) : none -->
            <div class="body dev_headerLine" :class="temperatureData.length === 0 ? 'none' : ''">
              <div class="table thead">
                <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                <div class="fixed grid">
                  <div class="unit">
                    {{ $t('gr102.total') }} <span>{{temperatureData.length}}</span> {{ $t('gr102.countUnit') }}
                  </div>
                  <div class="excel" @click="excelDownload">
                    {{ $t('common.download') }}
                  </div>
                  <div class="contain">
                    <table class="dev_aplList">
                      <colgroup>
                        <col class="date" />
                        <col class="course" />
                        <col v-for="i in maxHoleCnt" :key="i" class="hole" />
                      </colgroup>
                      <thead>
                      <tr>
                        <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                        <th class="date sort" @click="headerSort('date')">
                          <div class="item">
                            {{ $t('gr102.date') }}
                          </div>
                        </th>
                        <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                        <th class="course">
                          <div class="item">
                            {{ $t('common.course') }}
                          </div>
                        </th>
                        <th v-for="i in maxHoleCnt" :key="i" class="hole">
                          <div class="item">
                            Hole {{i}}
                          </div>
                        </th>
                      </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
              <div class="table tbody">
                <div class="contain">
                  <table>
                    <colgroup>
                      <col class="date" />
                      <col class="course" />
                      <col v-for="i in maxHoleCnt" :key="i" class="hole" />
                    </colgroup>
                    <tbody>
                    <tr v-for="tempInfo in temperatureData" :key="tempInfo.date + tempInfo.courseId">
                      <td class="date">
                        <div class="item">
                          {{setDateFormat(tempInfo.date, 'YYYY-MM-DD')}}
                        </div>
                      </td>
                      <td class="course">
                        <div class="item">
                          {{tempInfo.course}}
                        </div>
                      </td>
                      <td v-for="holeNo in maxHoleCnt" :key="holeNo">
                        <div class="item">
                          {{tempInfo.items.find(it => viewHoleNo(it.hlidx) === holeNo) === undefined ? '-' : tempInfo.items.find(it => viewHoleNo(it.hlidx) === holeNo).minTemp + ' / ' + tempInfo.items.find(it => viewHoleNo(it.hlidx) === holeNo).maxTemp}}
                        </div>
                      </td>
                    </tr>
                    </tbody>
                    <tbody class="none">
                    <tr>
                      <td colspan="20">
                        {{ $t('gr102.noData') }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
          <section class="section06">
            <div class="object01">
              {{ $t('gr102.viewDetailOnPc') }}
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="formSelectPopup typeSearch select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr102.selectGolfClubPlaceholder')" v-model="searchValue" v-on:keyup="changeSearchValue" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                      <label>
                        <input type="radio" v-model="selectCcode" :value="clubInfo.ccode" v-on:change="confirmSelect01()"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel" @click="closeSelectAll()">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm" @click="confirmSelect01()">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr102.selectTypePlaceholder')" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li @click="moveMenu(`/GR101` + getCurrentCcodeParam())">
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ $t('gr102.hourlyGreenTemperature') }}</span>
                      </label>
                    </li>
                    <li @click="closeSelectAll">
                      <label>
                        <input type="radio" checked/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ $t('gr102.periodGreenTemperature') }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select03">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select03">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr102.selectTypePlaceholder')" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="courseInfo in courseList" :key="courseInfo.courseId">
                      <label>
                        <input type="radio" v-model="selectCourseId" :value="courseInfo.courseId" v-on:change="confirmSelect03()"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{courseInfo.name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'

import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import {commonService, gcsService, clubInfoService, userService} from '../../router'

export default {
  name: 'GR102',
  data () {
    return {
      userInfo: {},
      maxHoleCnt: 0,
      dateRange: [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],
      sDate: '',
      eDate: '',
      sortColumn: 'date',
      sortType: 'desc',
      temperatureData: []
    }
  },
  created: function () {
    let fromDate = new Date().setDate(new Date().getDate() - 7)
    let toDate = new Date()
    this.sDate = moment(fromDate).format('YYYY-MM-DD')
    this.eDate = moment(toDate).format('YYYY-MM-DD')
    userService.getAll().then(response => {
      this.userInfo = response.data
      clubInfoService.getClubInfoList('active').then(response => {
        this.clubInfoList = response.data.clubInfoList
        this.selectClubInfoList = response.data.clubInfoList
        if (this.userInfo.userRole === 'ClubManager') {
          this.currentClubCode = this.userInfo.ccode
        } else {
          if (this.$route.query.ccode === undefined) {
            this.currentClubCode = this.clubInfoList[0].ccode
          } else {
            this.currentClubCode = this.$route.query.ccode
          }
        }
        this.setClubInfo()
        this.setData()
        this.selectCcode = this.currentClubCode
        commonService.getCourseListByCcode(this.currentClubCode).then(response => {
          this.courseList = response.data.courseList
          for (let i in this.courseList) {
            let holeCnt = this.courseList[i].endIdx - this.courseList[i].startIdx
            if (this.maxHoleCnt < holeCnt) this.maxHoleCnt = holeCnt
          }

          if (this.courseList[0] !== undefined) {
            this.currentCourseInfo = this.courseList[0]
            this.selectCourseId = this.courseList[0].courseId
          }
          this.setData()
        }).catch(error => {
          console.log('getCourseListByCcode.err.===>', error)
        })
      }).catch(error => {
        console.log('getClubInfoListByStatusActive.err.===>', error)
      })
    })
  },
  mounted: function () {
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout,
    DatePicker
  },
  methods: {
    setData: function () {
      if (this.currentClubInfo.ccode !== '') {
        gcsService.getTemperaturePeriod(this.currentClubInfo.ccode, this.currentCourseInfo.courseId, this.sDate, this.eDate).then(response => {
          this.temperatureData = response.data.temperatureData === undefined ? [] : response.data.temperatureData
        }).catch(error => {
          console.log('getTemperaturePeriod.err.===>', error)
        })
      }
    },
    getCurrentCcodeParam: function () {
      let currentCcode = localStorage.getItem('currentCcode')
      if (currentCcode) {
        return `?ccode=${currentCcode}`
      } else {
        return ''
      }
    },
    getCourseData: function (hlidx) {
      return this.courseList.find(it => ((it.startIdx <= hlidx) && (it.endIdx > hlidx)))
    },
    viewHoleNo: function (hlidx) {
      let startIdx = this.getCourseData(hlidx) === undefined ? 0 : this.getCourseData(hlidx).startIdx
      return (hlidx - startIdx) + 1
    },
    confirmSelect01: function () {
      this.currentClubCode = this.selectCcode
      this.setClubInfo()
      commonService.getCourseListByCcode(this.currentClubCode).then(response => {
        this.courseList = response.data.courseList
        this.courseList.unshift({
          courseId: '',
          name: this.$t('common.all')
        })
        this.currentCourseInfo = this.courseList[0]
        this.selectCourseId = this.courseList[0].courseId
        this.setData()
      }).catch(error => {
        console.log('getCourseListByCcode.err.===>', error)
      })
      this.closeSelectAll()
    },
    confirmSelect03: function () {
      this.currentCourseInfo = this.courseList.find(it => it.courseId === this.selectCourseId)
      this.setData()
      this.closeSelectAll()
    },
    excelDownload: function () {
      gcsService.getTemperaturePeriodExcelDownload(this.currentClubInfo.ccode, this.currentCourseInfo.courseId, this.sDate, this.eDate).then(response => {
      }).catch(error => {
        console.log('getTemperaturePeriodExcelDownload.err.===>', error)
      })
    },
    updateValues: function (dateRange) {
      this.sDate = moment(dateRange[0]).format('YYYY-MM-DD')
      this.eDate = moment(dateRange[1]).format('YYYY-MM-DD')
      this.setData()
    },
    setSearchPeriod: function (months, emit) {
      let fromDate = new Date(new Date().setMonth(new Date().getMonth() - months))
      let toDate = new Date()
      this.sDate = moment(fromDate).format('YYYY-MM-DD')
      this.eDate = moment(toDate).format('YYYY-MM-DD')
      this.dateRange[0] = fromDate
      this.dateRange[1] = toDate
      this.setData()
      emit(this.dateRange)
    },
    headerSort: function (target) {
      if (document.querySelector('.dev_aplList thead tr th.ascending') !== null) {
        document.querySelector('.dev_aplList thead tr th.ascending').classList.remove('ascending')
      }
      if (document.querySelector('.dev_aplList thead tr th.descending') !== null) {
        document.querySelector('.dev_aplList thead tr th.descending').classList.remove('descending')
      }
      if (this.sortColumn === target) {
        if (this.sortType === 'asc') {
          this.sortType = 'desc'
          document.querySelector('.dev_aplList thead tr th.' + target).classList.add('descending')
          this.temperatureData.sort(this.descSort)
        } else {
          this.sortType = 'asc'
          document.querySelector('.dev_aplList thead tr th.' + target).classList.add('ascending')
          this.temperatureData.sort(this.ascSort)
        }
      } else {
        document.querySelector('.dev_aplList thead tr th.' + target).classList.add('ascending')
        this.sortColumn = target
        this.sortType = 'asc'
        this.temperatureData.sort(this.ascSort)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gcs/GR102.vue